import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatMetres } from "../formatMetres";
import { parseHeight } from "./parseHeight";
import type { HeightEntryProps } from "./types";

export const HeightEntry = ({ initialM, onSubmit, onCancel }: HeightEntryProps) => {
  const { t, i18n } = useTranslation();
  const [text, setText] = useState(() =>
    formatMetres({ value: initialM, language: i18n.language, fractionDigits: 2 }),
  );

  const heightM = parseHeight(text);

  const submit = () => {
    if (heightM === null) return;
    onSubmit(heightM);
  };

  return (
    <div
      data-testid="karl-height-entry"
      className="mt-2.5 flex items-center gap-1.5 rounded-lg border border-blue-300 bg-white p-2"
    >
      <input
        autoFocus
        inputMode="decimal"
        value={text}
        aria-label={t("smartSurveyor.cablesBeta.askHeightEntryLabel")}
        onChange={(event) => setText(event.target.value)}
        onFocus={(event) => event.target.select()}
        onKeyDown={(event) => {
          if (event.key === "Enter") submit();
          if (event.key === "Escape") onCancel();
        }}
        className="w-24 min-w-0 rounded-md border border-slate-300 px-2.5 py-2 text-right text-[16px] tabular-nums text-slate-800 outline-none focus:border-blue-500"
      />
      <span className="text-[16px] text-slate-700">m</span>
      <button
        type="button"
        disabled={heightM === null}
        onClick={submit}
        className="ml-auto rounded-md bg-blue-600 px-3 py-2 text-[14px] font-semibold text-white hover:opacity-90 disabled:opacity-40"
      >
        {t("smartSurveyor.cablesBeta.askHeightSave")}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="rounded-md px-2.5 py-2 text-[14px] text-slate-600 hover:bg-slate-100"
      >
        {t("smartSurveyor.cablesBeta.cancel")}
      </button>
    </div>
  );
};
